import { render, staticRenderFns } from "./add-edit-consent.vue?vue&type=template&id=c6e86464&scoped=true&"
import script from "./add-edit-consent.vue?vue&type=script&lang=js&"
export * from "./add-edit-consent.vue?vue&type=script&lang=js&"
import style0 from "./add-edit-consent.vue?vue&type=style&index=0&id=c6e86464&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e86464",
  null
  
)

component.options.__file = "add-edit-consent.vue"
export default component.exports